import React from "react";
import { MessageDescriptor, useIntl } from "react-intl";

import { Select } from "src/common/components/Select";
import { useFormatMessageMap } from "src/common/hooks/useFormatMessageMap";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import {
	useLogProp,
	useMessageProps,
	useValue
} from "src/features/forms/hooks/useField";
import { SelectProps } from "src/features/forms/types";

export const SelectRenderer: React.FunctionComponent<SelectProps> = ({
	labels,
	placeholder,
	...directProps
}) => {
	const { formatMessage } = useIntl();
	const isLocked = React.useContext(IsLockedContext);
	const options = useOptions(labels);
	const [value, onChangeValue] = useValue<string | undefined>(undefined);
	return (
		<Select
			{...directProps}
			disabled={isLocked}
			placeholder={
				placeholder === undefined
					? undefined
					: formatMessage(placeholder)
			}
			options={options}
			value={value}
			onChangeValue={onChangeValue}
		/>
	);
};

function useOptions(messages: {
	[key: string]: MessageDescriptor;
}): { label: string; value: string }[] {
	const formatMessage = useFormatMessageMap();
	const messageProps = useMessageProps();
	const values = useLogProp<string[]>(messageProps, "values", []);
	return React.useMemo(
		() =>
			values.map(value => ({
				label: formatMessage(messages, value),
				value
			})),
		[messages, values, formatMessage]
	);
}
